import React, { useState, useEffect } from "react";
import Header from "../../Common/Header/header";
import Sidebar from "../../Common/Sidebar/sidebar";
import "./stateMaster.css";
import Modal from "react-bootstrap/Modal";
import Body from "../../Common/Body/body";
import { CreateStateDetails, GetState, GetAllCountryDetails } from "../../Apis/countryApi";
// import BaseComponent from "../baseComponent";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { Puff } from "react-loader-spinner";
import { TableLoader } from "../../Common/ShimmerLoader";

const StateMaster = () => {
  const [lgShow, setLgShow] = useState(false);
  const [states, setStates] = useState([]);
  const [newStateName, setNewStateName] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [status, setStatus] = useState("")
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const headers = ["country_name","state_name", "status"];

  const handleClose = () => setLgShow(false);

  // const columns = [
  //   {
  //     name: 'S.No',
  //     selector: (row,index ) => index + 1,
  //     sortable: true,
  //     // format: (row, rowIndex) => rowIndex + 1,
  //   },
  //   {
  //     name: 'Country Name',
  //     selector: (row)=>row.country_name,
  //     sortable: true,
  //   },
  //   {
  //     name: 'State Name',
  //     selector: (row)=>row.state_name,
  //     sortable: true,
  //   },
  //   {
  //     name: 'Status',
  //     selector: (row) => row.status,
  //   },
  //   {
  //     name: 'Action',
  //     cell: (row) => (
  //       <div className="d-flex">
  //       <button
  //                       style={{
  //                         backgroundColor: "#F8CCCD",
  //                         marginRight: "5px",
  //                         borderRadius: "4px",
  //                         border: "1px solid #EC1117",
  //                       }}
  //                       onClick={() => handleEdit}
  //                     >
  //                       <FontAwesomeIcon icon={faEdit} />
  //                     </button>
  //       <button
  //       style={{
  //         backgroundColor: "#FBE6E8",
  //         borderRadius: "4px",
  //         border: "1px solid #EC1117", 
  //       }}
  //     >
  //       View
  //     </button>
  //     </div>
  //     )
  //   },

  // ];
 
    const fetchData = async () => {
      try {
        const data = await GetState();
        setStates(data);
        setIsOptionsLoading(false)
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    useEffect(() => {
    fetchData();
  }, [lgShow]);

  // const handleEdit =() => setLgShow(true)
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const data = await GetAllCountryDetails();
  //       console.log("Country Data:", data);
  //       setCountries(data);
  //       console.log("Updated Countries State:", countries);
  //     } catch (error) {
  //       console.error("Error fetching countries:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const addState = async () => {
    try {
      const response = await CreateStateDetails({
        state: newStateName,
        country_id: selectedCountry.id,
      });
      const newState = await response.json();
      setStates((prevStates) => [...prevStates, newState]);

      setNewStateName("");
    } catch (error) {
      console.error("Error adding state:", error);
    }
  };

  const handleAdd = () => {
    if (newStateName.trim() === "") {
      alert("Please enter a valid state name");
      return;
    }
    addState();
    setLgShow(false)
  };

  return (
    <>
      <div style={{width:"100%"}}>
        <div className="content">
        <div className="page-content">
          <div className="page-header">
          <h4 style={{ display: "flex", marginTop: "30px" }}>
                States 
              </h4>
              <div className="card">
              <div className="card-body">
              <div
                  className="text-end mb-3"
                >
              {/* <button 
              className="btn btn-danger"
              style={{ backgroundColor: "rgb(236, 17, 23)" }}
               onClick={() => setLgShow(true)}>
                <i className="fa-solid fa-plus me-1"></i> Add States
              </button> */}

              
              {/* {states.length > 0 ? (
            <DataTable
                  columns={columns}
                  data={states}
                  pagination
                  customStyles={{
                    rows: {
                      style: {},
                    },
                    headCells: {
                      style: {
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        color: 'black',
                        backgroundColor: 'rgb(204, 204, 204)',
                        fontFamily: 'Poppins',
                        fontWeight: '600',
                      },
                    },
                    cells: {
                      style: {
                        paddingLeft: '8px',
                        paddingRight: '8px',
                      },
                    },
                  }}
                  highlightOnHover
                  noDataComponent="Loading..."
                />
                ) : (
                  <p>No states available</p>
                )} */}
                </div>

                {/* {isOptionsLoading ? (
                    <div className="row text-center">
                      <div className="col text-center">
                        <Puff
                          visible={true}
                          height="96"
                          width="96"
                          strokeWidth="5"
                          color="red"
                          ariaLabel="rings-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    </div>
                  ) : (
                    states && states.length > 0 ? ( */}
                <TableComponent isLoading={isOptionsLoading}
                  DataFetchURL={states}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  />
                    {/* ) : (
                      <div>No data found</div>
                    )
                  )} */}
          </div>
          </div>
        </div>
        </div>
        </div>
        </div>
      {/* <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header >
          <Modal.Title id="example-modal-sizes-title-lg">Add City</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Select Country Name</label>
                  <select
                    className="form-select"
                    value={selectedCountry ? selectedCountry.country_name : ""}
                    onChange={(e) => {
                      const selectedCountryId = e.target.value;
                      const selectedCountryObject = countries.find(
                        (country) => country.country_name === selectedCountryId
                      );
                      setSelectedCountry(selectedCountryObject);
                    }}
                  >
                    <option value="" disabled>Select Country</option>
                    {countries.map((country) => (
                      <option
                        key={country.country_name}
                        value={country.country_name}
                      >
                        {country.country_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label"> Enter State Name</label>
                  <input type="text"
                    name="" className="form-control"
                    value={newStateName}
                    onChange={(e) => setNewStateName(e.target.value)} />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      value="1"
                      id="activeRadio"
                      checked={status === "1"}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="status"
                      id="inactiveRadio"
                      value="2"
                      checked={status === "2"}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={handleClose}
              >
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={handleAdd}>
                Create
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default StateMaster;